import VnsMonitorRepository from "@/repositories/vns/VnsMonitorRepository";

export default {
    name: 'monitor',
    namespaced: true,
    state: {
        isLoading: false,
        ip: [],
        status: [],
        sensor: [],
        log: [],
        geolocation: {},
        jira: [],
        latestsJira: [],
    },
    getters: {
        isLoading (state) {
            return state.isLoading
        },
        getIp (state) {
            return state.ip
        },
        getStatus (state) {
            return state.status
        },
        getJira (state) {
            return state.jira
        },
        getLatestsJira (state) {
            return state.latestsJira
        },
        latestStatus(state) {
            if (state.status.length > 0){
                return state.status[state.status.length - 1]
            }
            return null
        },
        getSensor (state) {
            return state.sensor
        },
        getLog (state) {
            return state.log
        },
        getGeolocation (state) {
            return state.geolocation
        }
    },
    mutations: {
        setLoading (state, boolean) {
            state.isLoading = boolean
        },
        setIp (state, array) {
            state.ip = array
        },
        setStatus (state, array) {
            state.status = array
        },
        setJira (state, array) {
            state.jira = array
        },
        setLatestsJira (state, array) {
            state.latestsJira = array
        },
        setSensor (state, array) {
            state.sensor = array
        },
        setLog (state, array) {
            state.log = array
        },
        setGeolocation (state, obj) {
            state.geolocation = obj
        }
    },
    actions: {
        async listIp ({ commit }, params) {
            await VnsMonitorRepository.fetchIp(params).then(response => {
                commit('setIp', response.data)
            })
        },
        async listLastIp ({ commit }, vnsId) {
            await VnsMonitorRepository.fetchLastIp(vnsId).then(response => {
                commit('setIp', [response.data])
            })
        },
        async listStatus ({ commit }, params) {
            await VnsMonitorRepository.fetchStatus(params).then(response => {
                commit('setStatus', response.data)
            })
        },
        async listStatusToMonitor ({ commit }, params) {
            commit('setLoading', true)
            await VnsMonitorRepository.fetchStatusToMonitor().then(response => {
                commit('setStatus', response.data)
            })
            commit('setLoading', false)
        },
        async listJiraToMonitor ({ commit }, params) {
            commit('setLoading', true)
            await VnsMonitorRepository.fetchJiraToMonitor().then(response => {
                commit('setJira', response.data)
            })
            commit('setLoading', false)
        },
        async listLatestsJira ({ commit }, vnsId) {
            commit('setLoading', true)
            await VnsMonitorRepository.fetchLatestsJira(vnsId).then(response => {
                commit('setLatestsJira', response.data)
            })
            commit('setLoading', false)
        },
        async listLastStatus ({ commit }, vnsId) {
            await VnsMonitorRepository.fetchLastStatus(vnsId).then(response => {
                commit('setStatus', [response.data])
            })
        },
        async listSensor ({ commit }, params) {
            await VnsMonitorRepository.fetchSensor(params).then(response => {
                commit('setSensor', response.data)
            })
        },
        async listLog ({ commit }, id) {
            await VnsMonitorRepository.fetchLog(id).then(response => {
                commit('setLog', response.data)
            })
        },
        async listLastGeolocation ({ commit }, vnsId) {
            await VnsMonitorRepository.fetchLastGeoLocation(vnsId).then(response => {
                if (response.data.latitude && response.data.longitude) {
                    commit('setGeolocation', {
                        lat: Number.parseFloat(response.data.latitude),
                        lng: Number.parseFloat(response.data.longitude),
                        created_at: response.data.created_at
                    })
                }
            })
        }
    }
}
